module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ca":{"AGENDA":"AGENDA"},"es":{"AGENDA":"AGENDA"},"en":{"AGENDA":"SCHEDULE"},"fr":{"AGENDA":"L\u0027AGENDA"}}')
  delete Component.options._Ctor
}
